const NAV = {
    header: document.getElementById('header'),
    onReady() {
        NAV.onScroll();
        NAV.highlight();
        NAV.openSubnav();
        NAV.mobileNav();
        NAV.mobileSubnav();
    },
    onScroll() {
        window.addEventListener('scroll', () => {
            (window.scrollY > 100 && window.innerWidth > 1366) ? NAV.header.classList.add('onscroll') : NAV.header.classList.remove('onscroll');
        });
    },
    highlight() {
        let url = window.location.pathname;
        let urlArr = url.split('/');
        let navItems = document.querySelectorAll('.header__item > a');
        if (urlArr[1] === '') return;
        navItems.forEach(item => {
            let href = item.href;
            href.includes(urlArr[1]) && item.parentElement.classList.add('current');
        });
    },
    openSubnav() {
        let header      = document.querySelector('.header');
        let headerItems = document.querySelectorAll('.header__item');
        if (window.innerWidth > 1366) {
            headerItems.forEach(item => {
                item.addEventListener('mouseover', () => {
                    NAV.closeSubnav();
                    (item.nextElementSibling !== null) && (
                        item.classList.add('active'),
                        item.nextElementSibling.classList.add('active')
                    );
                });
            });
            document.addEventListener('click', event => {
                NAV.closeSubnav();
            });
            header.addEventListener('mouseleave', () => {
                NAV.closeSubnav();
            });
        }
    },
    closeSubnav() {
        let openItems   = document.querySelectorAll('.header__item.active');
        let openSubNavs = document.querySelectorAll('.header__subnav.active');
        openItems.forEach(item => {
            item.classList.remove('active');
        });
        openSubNavs.forEach(item => {
            item.classList.remove('active');
        });
    },
    mobileNav() {
        const burger     = document.getElementById('burger');
        const navigation = document.querySelector('.header__navigation');
        if (burger === null) return;
        burger.addEventListener('click', () => {
            burger.classList.toggle('cross');
            document.body.classList.toggle('noscroll');
            NAV.header.classList.toggle('open');
        });
    },
    mobileSubnav() {
        let arrows = document.querySelectorAll('.header__subnav-icon');
        arrows.forEach(arrow => {
            arrow.addEventListener('click', () => {
                arrow.classList.toggle('open');
                arrow.parentNode.nextElementSibling.classList.toggle('active');
            });
        });
    }
}